import * as React from 'react';
import { StyledTermsAndConditionsLink } from './styles';
import { connect } from 'react-redux';
import html from '../../../../config/documents/tos.html';
import { Modal } from '../../../common/modal-with-html';
import PropTypes from 'prop-types';
import { getText } from '../../../../utils/i18n';

export const TermsAndConditions = props => {
  const { customTOS, i18n } = props;
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <StyledTermsAndConditionsLink onClick={handleOpen}>
        Terms and Conditions{' '}
      </StyledTermsAndConditionsLink>
      <Modal
        modalHtml={html}
        dialogOpen={open}
        customModal={customTOS}
        modalTitle={getText(i18n, 'general.termsOfServiceTitle', 'Terms of Service')}
        setDialogClosed={() => handleClose()}
      />
    </>
  );
};
TermsAndConditions.propTypes = {
  i18n: PropTypes.object,
  customTOS: PropTypes.bool,
};

export const mapStateToProps = state => ({
  i18n: state.i18nSlice.i18n,
  customTOS: state.configurationSlice.features.features.customTOS,
  state,
});
export default connect(mapStateToProps)(TermsAndConditions);
